import { z } from "zod";

import { useStorage } from "@smart/itops-hooks-dom";
import { Alert } from "@smart/itops-sb-design-system-dom";

const dismissedSchema = z.boolean().optional();

type FeatureInfoProps = {
  featureName: string;
  heading: string;
  content: string;
};

export const FeatureInfo = ({
  featureName,
  heading,
  content,
}: FeatureInfoProps) => {
  const [isDismissed, setIsDismissed] = useStorage({
    defaultValue: undefined,
    key: featureName,
    schema: dismissedSchema,
    storage: "local",
  });

  if (isDismissed) return null;

  return (
    <div className="mx-auto max-w-screen-readable">
      <Alert
        variant="info"
        palette="branding"
        heading={heading}
        content={content}
        onClose={() => setIsDismissed(true)}
      />
    </div>
  );
};
